/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const DiscountTag: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M12.1318 2.00872L20.1318 3.07122L20.2958 3.10735C20.6658 3.22174 20.9424 3.54414 20.9921 3.93841L21.9921 11.8749L21.9999 11.9911C22.002 12.2233 21.9234 12.4495 21.7773 12.6298L21.6982 12.7158L11.9628 22.2158C11.571 22.598 10.9446 22.5941 10.5576 22.207L1.7929 13.4423C1.40581 13.0552 1.4019 12.4289 1.78412 12.037L11.2841 2.30169L11.371 2.22259C11.5831 2.05098 11.858 1.97234 12.1318 2.00872ZM3.90521 12.7265L11.2724 20.0937L19.9452 11.6308L19.1035 4.95208L12.3652 4.05657L3.90521 12.7265ZM13.9999 7.87884C14.5857 7.29305 15.5352 7.29305 16.121 7.87884C16.7068 8.46462 16.7068 9.41414 16.121 9.99993C15.5352 10.5856 14.5857 10.5857 13.9999 9.99993C13.4142 9.41418 13.4142 8.46463 13.9999 7.87884Z'
      fill='currentColor'
    />
  </React.Fragment>
)
